import { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import DataFilter from "src/components/common/frame/dataFilter";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData, 
    myAxios, 
    getTimeStamp, 
    scroll, 
    boolAndReducer,
    appTitle, 
    validURL,
    isDevMode
} from "src/components/common/functions";
import VendorForm from "./vendorForm";
import Detail from "./detail";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function Vendors({ tabTitle }){
    const dataFrame = [
        {label: "Vendor Name", key: "vendorName"}, 
        {label: "Website", key: "website"}, 
        {label: "Phone Number", key: "phoneNumber"}, 
        {label: "Extension", key: "extension"}, 
        {label: "Fax", key: "fax"}, 
        {label: "Country", key: "country"}, 
        {label: "State", key: "state"}, 
        {label: "City", key: "city"}, 
        {label: "Street", key: "street"}, 
        {label: "Postal Code", key: "postalCode"}, 
        {label: "Background", key: "background", noList: true}, 

        {label: "Creator", key: "creator"}, 
        {label: "Creation Date", type: "date", key: "created"}, 
        {label: "Updater", key: "updater"}, 
        {label: "Update Date", type: "date", key: "updated"}, 
    ];
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key,  item.default?item.default:""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const vendors = useMyStore(state => state.vendors);
    const setVendors = useMyStore(state => state.setVendors);
    const vendorDetails = useMyStore(state => state.vendorDetails);
    //-------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname + (history.location.hash ?? "");
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | "Add"
    const path3 = decodeURIComponent(path.split("/")[3] ?? ""); // "Edit"
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Vendors": vendors.updatedAt === null?getTimeStamp():vendors.updatedAt, 
        "Vendor Details": vendorDetails.updatedAt === null?getTimeStamp():vendorDetails.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showLoading, setShowLoading] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredVendors = vendors.data.filter(u => 
        (curFilter.vendorName?u.vendorName.toLowerCase().indexOf(curFilter.vendorName) > -1:true)
        && (curFilter.website?u.website.toLowerCase().indexOf(curFilter.website) > -1:true)
        && (curFilter.phoneNumber?u.phoneNumber.toLowerCase().indexOf(curFilter.phoneNumber) > -1:true)
        && (curFilter.fax?u.fax.toLowerCase().indexOf(curFilter.fax) > -1:true)
        && (curFilter.street?u.street.toLowerCase().indexOf(curFilter.street) > -1:true)
        && (curFilter.city?u.city.toLowerCase().indexOf(curFilter.city) > -1:true)
        && (curFilter.state?u.state.toLowerCase().indexOf(curFilter.state) > -1:true)
        && (curFilter.postalCode?u.postalCode.toLowerCase().indexOf(curFilter.postalCode) > -1:true)
        && (curFilter.country?u.country.toLowerCase().indexOf(curFilter.country) > -1:true)
        && (curFilter.creator?u.creator?.replace(/ {2}/g," ") === curFilter.creator:true)
        && (curFilter.createdMin?u.dateCreated >= curFilter.createdMin:true)
        && (curFilter.createdMax?u.dateCreated <= curFilter.createdMax:true)
        && (curFilter.updater?u.updater?.replace(/ {2}/g," ") === curFilter.updater:true)
        && (curFilter.updatedMin?u.dateUpdated >= curFilter.updatedMin:true)
        && (curFilter.updatedMax?u.dateUpdated <= curFilter.updatedMax:true)
        && (curFilter.background?u.background.toLowerCase().indexOf(curFilter.background) > -1:true)    
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentPageVendors = filteredVendors.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredVendors.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        if(formData.get("website").length > 0 && !validURL(formData.get("website"))){
            window.alert("Website is invalid.");
            return;
        }
        setShowLoader(true);
        const res = await myAxios(formData.get("url"), formData);
        setShowLoader(false);
        if(!res) return;
        setVendors(res.data);
        history.push(`/${path1}`);
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(isDevMode) console.log("UseEffect main");
            setShowLoading(true);
            const res = await myAxios("vendor/readVendors.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            setVendors(res.data, updateDateTime["Vendors"]);
        }
        if(vendors.updatedAt !== updateDateTime["Vendors"]) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[history, updateDateTime, setVendors, vendors.updatedAt])
    useEffect(() => {
        if(!["Add", ""].includes(path2)){
            if(!vendors.data.find(vendor => vendor.vendorHashKey === path2)){
                history.replace(`/${path1}`);
                setCurrentPage(1);
                return;
            }
            const hashkeys = filteredVendors
            .map(filteredVendor => filteredVendor.vendorHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [filteredVendors, itemsPerPage, history, path1, path2, vendors.data])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
   return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button type = "button" data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <DataFilter
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    defaultFilter = {defaultFilter}
                    items = {vendors}
                    dataFrame = {dataFrame}
                    width = {"40rem"}
                />
                <Export
                    filteredVendors = {filteredVendors}
                />
                <button type = "button" className = "headerButton" onClick = {() => {history.push(`/${path1}/Add`)}}>Add</button>
                {path2 === "Add"?
                <VendorForm
                    closeIt = {() => history.push(`/${path1}/`)}
                    handleSubmit = {handleSubmit}
                    keyword = "Add"
                    postUrl = "vendor/createVendor.php"
                />:null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredVendors.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                <th>Vendor Name</th>
                                <th>Website</th>
                                <th>Phone Number</th>
                                <th>Fax</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPageVendors.map((vendor, key) => 
                            <Fragment key = {key}>
                            <tr>
                                <td>
                                    <button
                                        type = "button"
                                        className = {(path2 === vendor.vendorHashKey?"showMinus":"showPlus") + " childRow"}
                                        id = {vendor.vendorHashKey}
                                        onClick = {e => {
                                            if(path2 !== e.currentTarget.id){
                                                history.push(`/${path1}/${e.currentTarget.id}`);
                                                scroll(e.currentTarget.id);
                                            }else{
                                                history.push(`/${path1}`);
                                                scroll(null);
                                            }
                                        }}
                                    />
                                </td>
                                <td>{vendor.vendorName}</td>
                                <td>{vendor.website?<a id = {vendor.website} href = {vendor.website} target = "_blank" rel = "noreferrer">{vendor.website}</a>:<></>}</td>
                                <td>{vendor.phoneNumber?<a href = {`tel:+1${vendor.phoneNumber.replace(/-/g, "")}${vendor.extension?`,${vendor.extension}`:""}`}>{vendor.phoneNumber}{vendor.extension?` Ext. ${vendor.extension}`:null}</a>:<></>}</td>
                                <td>{vendor.fax?<a href = {"fax:+1" + vendor.fax.replace(/-/g, "")}>{vendor.fax}</a>:<></>}</td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <TransitionWidthHeight 
                                        classNames = "cssTDTransition"
                                        In = {path2 ===  vendor.vendorHashKey}
                                    >
                                        <Detail
                                            history = {history}
                                            path1 = {path1}
                                            path2 = {path2}
                                            path3 = {path3}
                                            handleSubmit = {handleSubmit}
                                            vendor = {vendor}
                                            setVendors = {setVendors}
                                            updateDateTime = {updateDateTime}
                                        />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredVendors.length?
                <Footer
                    length = {filteredVendors.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}